enum EToastVariant {
	error = 'error',
	information = 'information',
	success = 'success'
}

export { EToastVariant };
